import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BoxDesign from './BoxDesign';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { langDateChange } from '../Inputs/DateInputWTitle';
import { LoadingColor } from '../LoadingColor';
import { formatPrice } from '../Functions/Price';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconHotels } from '../../Assets/panels/IconHotels';
import { IconNight } from '../../Assets/panels/IconNight';
import { IconReserve } from '../../Assets/panels/IconReserve';
import { IconStar } from '../../Assets/panels/IconStar';
const Styles = styled.div`
    width: 100%;
    .over-route {
        margin: 0 1rem 1rem;
        padding: 1.25rem;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .title-part {
            color: var(--text-h);
            display: flex;
            align-items: center;
            gap: 1rem;
            &.active {
                color: var(--main-color);
                .icon {
                    fill: var(--main-color);
                }
            }
            &.inside {
                color: #000000;
                .icon {
                    fill: var(--n-grey-2);
                }
            }
            .icon {
                fill: var(--text-h);
                width: 48px;
                height: 48px;
                display: block;
            }
            .text {
                font-weight: 700;
                font-size: 1.25rem;
            }
        }
        .line {
            height: 1px;
            background-color: var(--n-grey-1);
        }
        .box-hotel {
            display: flex;
            gap: 1rem;
            align-items: center;
            .image {
                width: 30%;
                max-width: 350px;
                aspect-ratio: 1.8;
                background-color: #6ABBAB;
                border: 1px solid var(--n-grey-1);
                border-radius: var(--border-radius-3);
                overflow: hidden;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .line-h {
                align-self: normal;
                width: 1px;
                background-color: var(--n-grey-11);
                color: #FFFFFF00;
            }
            .data {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
                flex-grow: 1;
                &.small-gap {
                    gap: 0.75rem;
                }
                .title {
                    font-size: 1.5rem;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    svg {
                        fill: var(--main-color);
                        width: 48px;
                        height: 48px;
                        display: block;
                    }
                }
                .detail {
                    font-size: 1.25rem;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    svg {
                        fill: var(--n-grey-2);
                        width: 32px;
                        height: 32px;
                        display: block;
                    }
                }
                .stars {
                    font-size: 1rem;
                    font-weight: 500;
                    color: var(--n-grey-2);
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    svg {
                        fill: var(--n-grey-2);
                        &.active {
                            fill: #FCCA3D;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        .over-route  {
            .box-hotel {
                .image {
                    width: 40%;
                    aspect-ratio: 1;
                }
                .data {
                    .title {
                        gap: 0.5rem;
                        svg {
                            width: 32px;
                            height: 32px;
                        }
                        font-size: 1.1rem;
                    }
                    .stars {
                        font-size: 0.75rem;
                        gap: 0.25rem;
                        svg {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }
            }
        }
    }
`
export default function TourDetailsHotelsCart ({loading = true, data, lang}){
    const makeStars = (num) => {
        let stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <IconStar className={((i < num) ? "active" : "")}/>
            );
        }
        return <div>{stars}</div>
    }
    const makeHotels = () => {
        let details = data.HOTELS ? data.HOTELS : []
        return details.map((v, i) => {
            return (
                <BoxDesign className='over-route' key={i + "b"}>
                <div className='box-hotel' key={i + "b"}>
                    <div className='image'>
                        <img src={v.Hotel_Logo} alt={v.Hotel_Name}/>
                    </div>
                    <div className='data small-gap'>
                        <div className='title'>
                            <IconHotels/>
                            {lang === "fa" ? v.Hotel_Name : v.Hotel_En_Name}
                        </div>
                        <div className='stars'>
                            {DictioneryPanel.packagesDict.hotelStar[lang]}: {makeStars(v.Hotel_Star)}
                        </div>
                    </div>
                    {/* <div className='line-h'></div>
                    <div className='data'>
                        <div className='detail'>
                            <IconNight/>
                            ۷ شب
                        </div>
                        <div className='detail'>
                            <IconReserve/>
                            همراه با صبحانه
                        </div>
                    </div> */}
                </div>
                </BoxDesign>
            )
        });
    }
    if(loading){
        return (
            <Styles>
                <LoadingColor/>
            </Styles>
        )
    }
    return (
        <Styles>
            {makeHotels()}
        </Styles>
    )
}